import React, { FC } from "react";

import SecurityTopic from "@/pages/SecurityAwareness/components/SecurityTopic";
import { ITopic, SecurityTopicEnum } from "@/pages/SecurityAwareness/types";

import {
  physicalSecurityQuiz,
  physicalSecuritySlides,
} from "@/constants/physical";

export const PhysicalSecurity: FC<ITopic> = ({
  handleNextTopic,
  isPassed,
  setTestResults,
}) => {
  return (
    <SecurityTopic
      slides={physicalSecuritySlides}
      quizName={SecurityTopicEnum.PhysicalSecurity}
      quizList={physicalSecurityQuiz}
      handleNextTopic={handleNextTopic}
      isPassed={isPassed}
      setTestResults={setTestResults}
    />
  );
};
